export default __webpack_public_path__ + "static/media/tea-cup-outline-16px.974cbe4a.svg";